import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { EmployeePositionService } from '../../../service/employee-position/employee-position.service';
import { EmployeePosition } from '../../../class/employee-position';

@Component({
  selector: 'app-employee-position',
  templateUrl: './employee-position.component.html',
  styleUrls: ['./employee-position.component.scss']
})
export class EmployeePositionComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoEmployeePositions: EmployeePosition;
    public employeePositions: EmployeePosition;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public employeePositionsService: EmployeePositionService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelEmployeePositions () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/employee-positions/employee-position/employee-position.component.ts